import React, { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as tagActions from "modules/tag";
import * as targetActions from "modules/target";
import * as currentStatusActions from "modules/currentStatus";
import * as targetLib from "libs/targetLib";

import fileDownload from "js-file-download";
import * as common from "libs/commonFunc";

import * as validFunc from "libs/validation";

import { getFormValues, isValid, reset } from "redux-form";
import { TargetHeader } from "components";

class CtTargetHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      excelFile: { acceptFile: [], rejectFile: [] },
      // isUpload - 0: 초기값, 1: 성공, 2: 실패
      uploadResult: { isUpload: 0, message: "" },
      isClicked: false,
      registerTag: [],
      searchText: "",
    };

    this.onAddTarget = this.onAddTarget.bind(this);
    this.onDeleteTarget = this.onDeleteTarget.bind(this);
    this.onExportTarget = this.onExportTarget.bind(this);
    this.onToggleModal = this.onToggleModal.bind(this);
    this.onTargetExcelDownload = this.onTargetExcelDownload.bind(this);
    this.onTargetExcelDrop = this.onTargetExcelDrop.bind(this);
    this.onTargetExcelSubmit = this.onTargetExcelSubmit.bind(this);
    this.onTargetExcelReset = this.onTargetExcelReset.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  // 성공 실패시 알림창
  onToggleSnackbar = (message) => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: "" });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 단일 대상자 태그 등록 - 선택한 태그 번호 배열 저장
  handleChangeTag = (e, rest) => {
    const value = rest && rest.value ? rest.value : [];

    this.setState({
      ...this.state,
      registerTag: value,
      searchText: "",
    });
  };

  // 단일 대상자 태그 등록 - 태그 검색창에 글자 입력 시
  handleSearchChange = (e) => {
    this.setState({
      searchText: e.target.value,
    });
  };

  // 단일 대상자 태그 등록 - 태그 검색 영역 이외의 영역 클릭 시
  handleBlur = (e) => {
    this.setState({
      searchText: "",
    });
  };

  // 대상자 등록(동작)
  onAddTarget = async () => {
    this.setState({ isClicked: true });
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      TagActions,
      TargetActions,
      formTargetAddStore,
      formTargetAdd,
      isValidFormTargetAdd,
      onGetTarget,
    } = this.props;

    try {
      // validation 처리
      if (
        isValidFormTargetAdd &&
        !(await validFunc.targetEmailValidate(formTargetAdd.targetEmail)) &&
        !(await validFunc.tagNameValidate(formTargetAdd.tagName))
      ) {
        // 대상자 생성 및 대상자에게 태그 부여
        await TargetActions.postTarget({
          tagNoArray: JSON.stringify(this.state.registerTag),
          // targetId: formTargetAdd.,
          targetName: formTargetAdd.targetName,
          targetEmail: formTargetAdd.targetEmail,
          targetPhone: formTargetAdd.targetPhone,
          targetDivision: formTargetAdd.targetDivision,
          targetPosition: formTargetAdd.targetPosition,
          isResurrection: formTargetAdd.isResurrection,
          // targetDetail: formTargetAdd.
        });

        onGetTarget(true);
        TagActions.getTag();
        if (!!this.props.scrollRef && !!this.props.scrollRef.scrollable) {
          this.props.scrollRef.scrollable.scrollTop = 0;
        }

        this.onToggleSnackbar(
          formTargetAdd.targetName +
            " " +
            defineMessages(
              formatMessage({
                id: "CtTargetHeader_1",
                defaultMessage: "대상자 등록",
              })
            )
        );
        this.onToggleModal("");
      } else {
        window.markFieldValidate(formTargetAddStore, "formTargetAdd");
      }

      setTimeout(() => {
        this.setState({ isClicked: false });
      }, 100);
    } catch (e) {
      console.log(e);
    }
  };

  // 대상자 삭제
  onDeleteTarget = async () => {
    this.setState({ isClicked: true });
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      TagActions,
      TargetActions,
      CurrentStatusActions,
      isValidFormTargetDelete,
      formTargetDelete,
      totalTargetCount,
    } = this.props;

    try {
      if (isValidFormTargetDelete) {
        const params = {
          isAllCheck: formTargetDelete.isAllCheck,
        };
        if (formTargetDelete.isAllCheck === 1) {
          params.tagNoArray = formTargetDelete.tagNoArray;
        } else {
          params.targetNoArray = formTargetDelete.targetNoArray;
        }

        await TargetActions.deleteTarget(params);

        CurrentStatusActions.initialTarget();
        TagActions.getTag();

        this.onToggleSnackbar(
          (formTargetDelete.isAllCheck === 1
            ? totalTargetCount
            : defineMessages(
                formatMessage({ id: "CtTargetHeader_4", defaultMessage: " " })
              ) + formTargetDelete.targetNoArray.split(",").length) +
            defineMessages(
              formatMessage({
                id: "CtTargetHeader_2",
                defaultMessage: "명의 대상자 삭제",
              })
            )
        );
        this.onToggleModal("");
      }
      setTimeout(() => {
        this.setState({ isClicked: false });

        // 삭제 후 대상자 다시 조회 처리(첫페이지 대상을 삭제 하면 리스트에 대상자가 없다고 표시됨)
        TargetActions.changeTarget({ name: "needReload", value: true });
      }, 100);
    } catch (e) {
      console.log(e);
    }
  };

  // 대상자 내보내기
  onExportTarget = async () => {
    this.setState({ isClicked: true });
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      isValidFormTargetExport,
      formTargetExport,
      targetParam,
      selectedTag,
      targetNoArray,
    } = this.props;

    try {
      if (isValidFormTargetExport) {
        const tagNoArray =
          (selectedTag.toJS().toString() === "all-tag" && "all-tag") ||
          (selectedTag.toJS().toString() === "no-tag" && "no-tag") ||
          JSON.stringify(selectedTag);
        const params = {
          tagNoArray: tagNoArray,
          sort: JSON.stringify(targetParam.get("sort")),
          filter: JSON.stringify(targetParam.get("filter")),
          isAllCheck: formTargetExport.isAllCheck,
        };

        if (targetNoArray.size > 0) {
          params.targetNoArray = JSON.stringify(targetNoArray.toJS());
        }

        const respObj = await targetLib.exportTargetAPI(params);

        if (respObj && respObj.status && respObj.status === 200) {
          if (respObj.data) {
            fileDownload(
              respObj.data,
              "MudFixTarget_" +
                common.timeFormatFromUTCEpoch(common.nowEpoch()) +
                ".xlsx"
            );
          } else {
            // 응답 데이터 오류
            console.log("fail");
          }
        }

        this.setState({ isClicked: false });
        this.onToggleModal("");
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 모달 처리
  onToggleModal = (viewType) => {
    const { ReduxFormReset } = this.props;
    if (viewType === "targetAdd") {
      ReduxFormReset("formTargetAdd");
    } else if (viewType === "targetAddExcel") {
      ReduxFormReset("formTargetUpload");
      this.setState({ uploadResult: { isUpload: 0, message: "" } });
    }

    this.onTargetExcelReset();

    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 대상자 엑셀 양식 다운로드
  onTargetExcelDownload = () => {
    // fake server request, getting the file url as response
    setTimeout(() => {
      window.location.href =
        "/fdata/serve/MudFixTargetUpload_" +
        localStorage.getItem("language") +
        ".xls";
    }, 100);
  };

  // 엑셀 양식 파일 drop 처리
  onTargetExcelDrop = (files) => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const fileName = files[0].name.split(".")[0];
    const ext = files[0].name.split(".")[1];
    if (
      (ext === "xls" || ext === "xlsx" || ext === "xlsm" || ext === "xlm") &&
      fileName.indexOf("MudFixTarget") !== -1
    ) {
      this.setState({
        uploadResult: { isUpload: 0, message: "" },
        excelFile: { acceptFile: files, rejectFile: [] },
      });
      // 양식 체크
    } else {
      this.setState({
        uploadResult: { isUpload: 0, message: "" },
        excelFile: { acceptFile: [], rejectFile: files },
      });
    }
  };

  // 엑셀 양식 업로드
  onTargetExcelSubmit = async () => {
    this.setState({ isClicked: true });

    try {
      const excelFile = this.state.excelFile["acceptFile"];
      if (!!excelFile.length > 0) {
        const formData = new FormData();
        excelFile.map((file) => {
          formData.append("name", file.name);
          formData.append("file", file);
        });

        formData.append(
          "isResurrection",
          !!this.props.formTargetUpload &&
            !!this.props.formTargetUpload.isResurrection
            ? this.props.formTargetUpload.isResurrection
            : 0
        );

        const respObj = await targetLib.postTargetExcelAPI(formData);

        if (respObj && respObj.status && respObj.status === 200) {
          if (respObj.data.list) {
            const {
              successCount,
              editCount,
              errCount,
              editInfo,
              errInfo,
              detailInfo,
            } = respObj.data.list;

            // 업로드 성공
            if (successCount > 0 || editCount > 0) {
              // 성공, 실패 둘다 있음
              if (errCount > 0) {
                const resultData = {};

                this.setState({
                  uploadResult: {
                    isUpload: 1,
                    resultData: {
                      successCount,
                      editCount,
                      editInfo,
                      errCount,
                      errInfo,
                      detailInfo,
                    },
                  },
                });
              } else {
                // 실패 없이 완전 성공
                this.setState({
                  uploadResult: {
                    isUpload: 1,
                    resultData: {
                      successCount,
                      editCount,
                      editInfo,
                      detailInfo,
                    },
                  },
                });
              }
              // this.onToggleModal('');
              const { TargetActions, TagActions } = this.props;
              // 태그 목록 새로고침
              TagActions.changeTag({ name: "needReload", value: true });
              // 대상자 목록 새로고침 처리
              TargetActions.changeTarget({ name: "needReload", value: true });
            } else {
              // 업로드 실패
              this.setState({
                uploadResult: {
                  isUpload: 2,
                  resultData: { errCount, errInfo, editCount, editInfo },
                },
              });
            }
          } else if (Array.isArray(respObj.data.error)) {
            // 업로드 실패
            this.setState({
              uploadResult: {
                isUpload: 4,
                resultData: {
                  errCount: 0,
                  errInfo: respObj.data.error[0].errInfo,
                },
              },
            });
          }
        } else {
          // 업로드 에러
          this.setState({ uploadResult: { isUpload: 3 } });
        }
      } else {
        // 파일 없음
      }
    } catch (e) {
      console.log(e);
    }

    setTimeout(() => {
      this.setState({ isClicked: false });
    }, 100);
  };

  // 엑셀 파일 초기화
  onTargetExcelReset = () => {
    this.setState({
      uploadResult: { isUpload: 0, message: "" },
      excelFile: { acceptFile: [], rejectFile: [] },
    });
  };

  // input에 값 입력 처리
  handleChange = (e) => {
    const { CurrentStatusActions } = this.props;
    const { name, value } = e.target;

    CurrentStatusActions.changeTag({
      name,
      value,
    });
  };

  render() {
    const {
      onAddTarget,
      onDeleteTarget,
      onExportTarget,
      onToggleModal,
      onTargetExcelDownload,
      onTargetExcelDrop,
      onTargetExcelSubmit,
      onTargetExcelReset,
      handleChange,
      handleChangeTag,
      handleSearchChange,
      handleBlur,
    } = this;
    const {
      isModal,
      selectedTag,
      selectTarget,
      totalTargetCount,
      tagDataByTagNo,
      targetDataByTargetNo,
    } = this.props;
    const {
      isClicked,
      excelFile,
      uploadResult,
      registerTag,
      searchText,
    } = this.state;

    return (
      <TargetHeader
        isModal={isModal}
        isClicked={isClicked}
        selectedTag={selectedTag}
        selectTarget={selectTarget}
        totalTargetCount={totalTargetCount}
        tagDataByTagNo={tagDataByTagNo}
        targetDataByTargetNo={targetDataByTargetNo}
        excelFileData={excelFile}
        excelUploadResult={uploadResult}
        onAddTarget={onAddTarget}
        onDeleteTarget={onDeleteTarget}
        onExportTarget={onExportTarget}
        onToggleModal={onToggleModal}
        onTargetExcelDownload={onTargetExcelDownload}
        onTargetExcelDrop={onTargetExcelDrop}
        onTargetExcelSubmit={onTargetExcelSubmit}
        onTargetExcelReset={onTargetExcelReset}
        handleChange={handleChange}
        handleChangeTag={handleChangeTag}
        registerTag={registerTag}
        handleSearchChange={handleSearchChange}
        handleBlur={handleBlur}
        searchText={searchText}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isModal: state.currentStatus.get("isModal"),
  selectedTag: state.currentStatus.getIn(["tag", "selectedTag"]),
  selectTarget: state.currentStatus.getIn(["target", "selectTarget"]),
  targetNoArray: state.currentStatus.getIn([
    "target",
    "selectTarget",
    "targetNoArray",
  ]),
  tagDataByTagNo: state.tag.get("tagDataByTagNo"),
  totalTargetCount: state.target.get("totalTarget"),
  targetParam: state.target.get("param"),
  targetDataByTargetNo: state.target.get("targetDataByTargetNo"),
  formTargetAddStore: state.form["formTargetAdd"],
  formTargetDeleteStore: state.form["formTargetDelete"],
  formTargetAdd: getFormValues("formTargetAdd")(state),
  formTargetUpload: getFormValues("formTargetUpload")(state),
  formTargetDelete: getFormValues("formTargetDelete")(state),
  formTargetExport: getFormValues("formTargetExport")(state),
  isValidFormTargetAdd: isValid("formTargetAdd")(state),
  isValidFormTargetDelete: isValid("formTargetDelete")(state),
  isValidFormTargetExport: isValid("formTargetExport")(state),
});

const mapDispatchToProps = (dispatch) => ({
  TagActions: bindActionCreators(tagActions, dispatch),
  TargetActions: bindActionCreators(targetActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(CtTargetHeader));



// WEBPACK FOOTER //
// ./src/script/containers/target/CtTargetHeader.js